import { render, staticRenderFns } from "./c_picture_cube.vue?vue&type=template&id=96ba9830&scoped=true"
import script from "./c_picture_cube.vue?vue&type=script&lang=js"
export * from "./c_picture_cube.vue?vue&type=script&lang=js"
import style0 from "./c_picture_cube.vue?vue&type=style&index=0&id=96ba9830&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ba9830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96ba9830')) {
      api.createRecord('96ba9830', component.options)
    } else {
      api.reload('96ba9830', component.options)
    }
    module.hot.accept("./c_picture_cube.vue?vue&type=template&id=96ba9830&scoped=true", function () {
      api.rerender('96ba9830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_picture_cube.vue"
export default component.exports